import React, { useState, useEffect } from "react";
import { useParams, useLocation, useHistory } from "react-router";
import css from "../../style/onbording.module.css";
import { FaCheckCircle } from "react-icons/fa";
import { FiChevronRight } from "react-icons/fi";
import { getStatus } from "../../store/actions/onboardingActions";
import { CircularProgress } from "@material-ui/core";
import { list as optionsList } from "../../utils/onboardingConstants";
import ErrorComponent from "../../components/ErrorComponent";

const Index = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [status, setStatus] = useState();
  const [list, setList] = useState([]);

  const history = useHistory();
  const { id } = useParams();
  const { search } = useLocation();

  const gotoPage = (item) => {
    if (item.isCompleted) return;
    history.push(`/Driver/mobile/${item.route}/${status.mooverType}/${id}`);
  };

  const handleCheckIfCompleted = (item) => {
    if (Array.isArray(item.propertyNames) && item.propertyNames.length) {
      const notUploaded = item.propertyNames.filter((name) => !!status[name]);
      return !!notUploaded.length;
    } else return !!status[item.propertyName];
  };

  const handleAllTasksCompleted = () => {
    let incompletedTasks = 0;
    if (Array.isArray(list) && list.length) {
      list.forEach((l) => {
        if (!l.isCompleted) incompletedTasks += 1;
      });
    }
    return incompletedTasks ? false : true;
  };

  useEffect(() => {
    if (id && search) {
      const params = new URLSearchParams(search);
      const token = params.get("token");
      localStorage.setItem("wemoovezdrivertoken", "Bearer " + token);
      getStatus(id, setStatus, setError, setLoading);
    }
  }, [id, search]);

  useEffect(() => {
    if (status)
      setList(
        optionsList.reduce(
          (newList, item) =>
            item.permissions.includes(status.mooverType)
              ? [
                  ...newList,
                  { ...item, isCompleted: handleCheckIfCompleted(item) },
                ]
              : newList,
          []
        )
      );
  }, [status]);

  return (
    <div className={css.mD}>
      {loading ? (
        <div style={{ textAlign: "center" }}>
          <CircularProgress />
        </div>
      ) : error ? (
        <ErrorComponent error={error} />
      ) : (
        <>
          <div className={css.mHeading}>
            Please upload your required documents
          </div>
          <div className={css.listMD}>
            {list.map((item) => (
              <div
                className={css.listBox}
                style={{
                  backgroundColor: item.isCompleted
                    ? "var(--primaryDark)"
                    : "white",
                  color: item.isCompleted ? "white" : "var(--grey)",
                }}
                onClick={() => gotoPage(item)}
              >
                <div className={css.listBoxText}>{item.title}</div>
                <div className={css.listBoxIcon}>
                  {item.isCompleted ? (
                    <FaCheckCircle style={{ color: "var(--secondary)" }} />
                  ) : (
                    <FiChevronRight />
                  )}
                </div>
              </div>
            ))}
          </div>
          {list.length && handleAllTasksCompleted() ? (
            <div className={css.mtext}>
              Thank you for completing all the tasks, your profile is under
              review, you can now navigate back to the home screen.
            </div>
          ) : (
            <></>
          )}
        </>
      )}
    </div>
  );
};

export default Index;
